<template>
  <div class="chart-and-summary">
    <div
      class="summarize"
    >
      <chart-summarize
        :title="chartAttr.title"
        :total="chartData.total"
        :prevTotal="chartData.prevTotal"
        :totalFormat="chartAttr.totalFormat"
      />
    </div>
    <div class="chart">
      <component
        :is="componentName"
        :labels="getTimeStampArray"
        :chartData="getChartArray"
        :styles="myStyles"
        :toolTipIndex="toolTipIndex"
        :chartAttr="chartAttr"
        @tooltipIndexChanged="tooltipIndexChanged"
      />
    </div>
  </div>
</template>

<script>
import BarChart from './BarChart'
import LineChart from './LineChart'
import ChartSummarize from './ChartSummarize'

export default {
  components: {
    BarChart,
    LineChart,
    ChartSummarize
  },
  props: {
    chartAttr: {
      type: Object,
      required: true
    },
    chartData: {
      type: Object,
      required: true
    },
    toolTipIndex: { // eslint-disable-line vue/require-default-prop
      type: Number
    }
  },
  data () {
    return {
      myStyles: {
        height: '100%'
      }
    }
  },
  computed: {
    componentName () {
      switch (this.chartAttr.type) {
        case 'barChart':
          return 'bar-chart'
        default:
          return 'line-chart'
      }
    },
    getTimeStampArray () {
      if (!this.chartData['data']) { return [] }
      return this.chartData['data'].map(chartData => chartData.date)
    },
    getChartArray () {
      if (!this.chartData['data']) return []
      return this.chartData['data'].map(chartData => chartData.val)
    }
  },
  methods: {
    tooltipIndexChanged (index) {
      this.$emit('tooltipIndexChanged', index)
    }
  }
}
</script>

<style scoped lang="scss">
.chart-and-summary {
  height: 100%;
  padding: 10px;

  .summarize {
    height: 50%;
    padding: 10px;
  }

  .chart {
    height: 50%;
  }
}
</style>
